// extracted by mini-css-extract-plugin
export default {"formRow":"FormRow_formRow__6AtDP","mobile":"FormRow_mobile__82x5F"};